/**
 * A case in which we might want to pivot is when we have regular season and playoff records
 * for each general manager, but want to combine them to show their overall totals.
 *
 * We can only PIVOT_BY when all data is returned from the API
 * Otherwise when we aggregate, we could be missing rows and get incorrect results
 *
 * In addition, if we pass the pivot_by into ReactTable after the pivot has already been
 * utilized in the prior aggregate function, our results can get skewed. The pivot_by in the react
 * table should only be used when we want to break down a record further. For example, if we want
 * to see a gm's franchise totals, and then open a drop down to break down each franchise's data, we
 * would want to utilize the pivot by in the react table.
 */
export const PIVOT_BY = {
    GENERAL_MANAGER_RECORDS: {
        'gm-wins-career-including-playoffs': ['generalManager.id'],
        'gm-wins-single-franchise-including-playoffs': ['generalManager.id', 'franchiseName'],
    },
    PLAYOFF_TEAM_RECORDS: {
        'team-potential-clinching-game-record': ['franchiseId'],
        'team-elimination-game-record': ['franchiseId'],
    },
};

export const PIVOT_BY_SORTS = {
    GENERAL_MANAGER_RECORDS: [
        { id: 'wins', desc: true },
        { id: 'games', desc: true },
    ],
    PLAYOFF_TEAM_RECORDS: [
        { id: 'winPctg', desc: true },
        { id: 'wins', desc: true },
    ],
};
